import ComposableTableHeader, { ComposableTableHeaderSortProps } from './ComposableTableHeader';

export default ComposableTableHeader;
export { ComposableTableHeaderSortProps };
